export enum BlobType {
  PHOTO = 'photo',
  VIDEO = 'video',
  INDEXED_DB = 'indexed-db',
  ODOMETER_READING = 'odometer-reading',
}
